// @spec NIS2-STR-004
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { NIS2ClassificationForm } from '@/features/nis2/classification';
import { useOrgRole } from '@/hooks/use-org-role';
import i18n from '@/lib/i18n';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_authenticated/settings/nis2-classification')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.nis2EntityClassification'),
  }),
  component: NIS2ClassificationPage,
});

/**
 * NIS2 entity classification settings page.
 *
 * Allows organization admins to:
 * - Configure entity type (Essential / Important)
 * - Select applicable NIS2 sectors (Annex I / Annex II)
 * - Set organization size criteria
 * - Configure jurisdictions and authority contacts
 * - Manage classification approval workflow
 */
function NIS2ClassificationPage() {
  const { t } = useTranslation('settings');
  const { isAdmin } = useOrgRole();

  return (
    <div className="p-8">
      <div className="mx-auto max-w-4xl space-y-8">
        <header>
          <h1 className="text-3xl font-semibold text-foreground">
            {t('nis2ClassificationPage.title')}
          </h1>
          <p className="mt-1 text-muted-foreground">{t('nis2ClassificationPage.description')}</p>
        </header>

        <section className="space-y-6">
          <NIS2ClassificationForm isAdmin={isAdmin} />
        </section>
      </div>
    </div>
  );
}
